import type { Enums } from "../types";

/**
 * This function returns the color for the given state.
 * @param state
 * @returns
 */
export function getStateColor(state: Enums<"state">): Enums<"color"> {
	switch (state) {
		case "active":
			return "emerald";
		case "inactive":
			return "red";
		case "pending":
			return "gray";
	}
}
